import { render, staticRenderFns } from "./SolicitudAvanceMas.vue?vue&type=template&id=5b6f185c"
import script from "./SolicitudAvanceMas.vue?vue&type=script&lang=js"
export * from "./SolicitudAvanceMas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports